"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhraseResultOutputType = void 0;
/**
 * The phrase result output type
 */
var PhraseResultOutputType;
(function (PhraseResultOutputType) {
    PhraseResultOutputType["Always"] = "Always";
    PhraseResultOutputType["None"] = "None";
})(PhraseResultOutputType = exports.PhraseResultOutputType || (exports.PhraseResultOutputType = {}));

//# sourceMappingURL=PhraseResults.js.map
